import React from "react";
import ReactModal from 'react-modal';
import '../../assets/css/modals/share.scss';
import { FacebookShareButton, WhatsappShareButton, EmailShareButton } from "react-share";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from "../../config/config";

function Share(props) {
  const shareUrl = window.location.href;
  const property = props.property;

  // Monta o texto para WhatsApp com quebra de linha
  const formatText = () => {
    const lines = [
      shareUrl,
      '',
      `📢 ${property?.negociacao}`, // Aluguel ou Venda
      `🏠 ${property?.tipo}`,
    ];

    if (!config.isEmptyNullOrUndefined(parseInt(property?.quartos))) lines.push(`🛏 Dormitórios: ${property.quartos}`);
    if (!config.isEmptyNullOrUndefined(parseInt(property?.suites))) lines.push(`🛁 Suítes: ${property.suites}`);
    if (!config.isEmptyNullOrUndefined(parseInt(property?.banheiros))) lines.push(`🚽 Banheiros: ${property.banheiros}`);
    if (!config.isEmptyNullOrUndefined(parseInt(property?.vagas))) lines.push(`🚗 Vagas: ${property.vagas}`);
    if (!config.isEmptyNullOrUndefined(parseInt(property?.area))) lines.push(`📐 Área útil: ${property.area} m²`);

    lines.push('', `💰 Valor: R$ ${parseFloat(!config.isEmptyNullOrUndefined(parseInt(property?.valor)) ? property?.valor : property?.valor_aluguel).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`);
    lines.push('', `🗺️ Em ${property?.bairro} - ${property?.cidade}/${property?.uf}`);
    lines.push('', '📝 Descrição:', property?.descricao);

    return lines.join('\n');
  };

  const whatsappMessage = encodeURIComponent(formatText());
  const whatsappUrl = `https://api.whatsapp.com/send?text=${whatsappMessage}`;

  return (
    <ReactModal
      isOpen={props.show}
      contentLabel="Compartilhar"
      ariaHideApp={false}
      overlayClassName="overlay-share"
      className="modal-share"
    >
      <div className="text-center mb-50">
        <h1 className="mb-30">Compartilhar</h1>
        <span>Selecione uma das opções abaixo:</span>
      </div>

      <div className="grid col-3 sm-gap mb-50">
        <FacebookShareButton
          url={shareUrl}
          quote={`${props.title}`}
        >
          <div className="share-button">
            <FontAwesomeIcon className="icon float-left" icon={['fab', 'facebook']} />
            <span className="float-left">Via Facebook</span>
          </div>
        </FacebookShareButton>
        <a href={whatsappUrl} target="_blank" rel="noreferrer">
          <div className="share-button">
            <FontAwesomeIcon className="icon float-left" icon={['fab', 'whatsapp']} />
            <span className="float-left">Via Whatsapp</span>
          </div>
        </a>
        <EmailShareButton
          url={shareUrl}
          subject={`${props.title}`}
          body={formatText()}
        >
          <div className="share-button">
            <FontAwesomeIcon className="icon float-left" icon={['far', 'envelope']} />
            <span className="float-left">Via Email</span>
          </div>
        </EmailShareButton>
      </div>

      <div className="flex jc-sb">
        <a href="https://portal.rankim.com/" className="flex ai-fc" onClick={props.hideModal}>Cancelar</a>
      </div>
    </ReactModal>
  );
}

export default Share;